/**
 * Remove pagination number in the end of the path
 *
 * @example
 * removePaginationFromPath('/news/1') // '/news'
 * removePaginationFromPath('/news/item/1') // '/news/item'
 * removePaginationFromPath('/en/news/item/1') // '/news/item'
 * removePaginationFromPath('/es/news/item/1') // '/es/news/item'
 *
 *
 * @param path string
 * @returns string without pagination number
 */

export function removePaginationFromPath(path: string) {
	return path
		.replace(/^\/en(\/|$)/, '/')
		.replace(/(\/\d+\/?)$/, '')
		.replace(/\/$/, '');
}
